import { Component, OnInit } from '@angular/core';
import {UserPrivacyService} from "./user-privacy.service";

@Component({
  selector: 'pbc-user-privacy',
  templateUrl: './user-privacy.component.html',
  styleUrls: ['./user-privacy.component.scss']
})
export class UserPrivacyComponent implements OnInit {

  showPrivacyPopup : boolean = false;

  constructor(
    private userPrivacyService : UserPrivacyService
  ) { }

  ngOnInit() {
    this.userPrivacyService.showUserPrivacy.subscribe((show : boolean) => {
      this.showPrivacyPopup = show;
    })
  }

  closePrivacyPopupClick() {
    this.showPrivacyPopup = false;
  }

}
